
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { CompetitiveAnalysisProps } from "./types/competitive-analysis";
import { CompetitiveMetricsTable } from "./competitive/CompetitiveMetricsTable";
import { Button } from "@/components/ui/button";
import { FileDown } from "lucide-react";
import { useState } from "react";
import { generateCSV } from "./csv/CSVGenerator";
import { toast } from "sonner";
import { KeywordSummary, URLAnalysis } from "@/types/seo";

interface ExtendedCompetitiveAnalysisProps extends CompetitiveAnalysisProps {
  keywordData: KeywordSummary;
}

export const CompetitiveAnalysis = ({ urlAnalyses, keywordData }: ExtendedCompetitiveAnalysisProps) => {
  const [isGeneratingCSV, setIsGeneratingCSV] = useState(false);

  const handleGenerateCSV = async () => {
    if (isGeneratingCSV) return;
    
    setIsGeneratingCSV(true);
    const toastId = toast.loading("Gerando CSV...");
    
    try {
      await generateCSV({ 
        keyword: keywordData.keyword,
        keywordData,
        urlAnalyses 
      });
      toast.success("CSV gerado com sucesso!", { id: toastId });
    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error(
        error instanceof Error ? error.message : "Erro ao gerar CSV",
        { id: toastId }
      );
    } finally {
      setIsGeneratingCSV(false);
    }
  };

  return (
    <Card className="mb-8">
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <div>
          <CardTitle>Análise Competitiva</CardTitle>
          <CardDescription>
            Comparação com os principais concorrentes. Essa comparação não leva em conta o fator mais importante: a intenção de busca. Use com moderação.
          </CardDescription>
        </div>
        <Button
          onClick={handleGenerateCSV}
          disabled={isGeneratingCSV}
          variant="outline"
          size="sm"
          className="flex items-center gap-2 text-sm whitespace-nowrap ml-4"
        >
          <FileDown className="w-4 h-4" />
          Baixar CSV
        </Button>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <CompetitiveMetricsTable urlAnalyses={urlAnalyses} />
        </div>
      </CardContent>
    </Card>
  );
};
